export default __webpack_public_path__ + "static/icon-8-6-622ae87ac8aca9451cc7bbcb579fcbe1.png";